// extracted by mini-css-extract-plugin
module.exports = {"subcategoryList":"_14Bsb","subcategoryIcon":"MqKq5","link":"_2niiD","labelWrapper":"_3Rzd4","label":"_1QEV9","newPostIndicator":"_1Jmh4"};